export function fail(message) {
    throw new Error(message);
}
export function assert(condition, message) {
    if (!condition) {
        fail(message ?? 'Assertion failed');
    }
}
export function assertNotUndefined(value, message) {
    assert(value !== undefined, message ?? 'Expected value to not be undefined, but it was.');
    return value;
}
export function assertNotNull(value, message) {
    assert(value !== null, message ?? 'Expected value to not be null, but it was.');
    return value;
}
export function assertDefined(value, message) {
    assertNotUndefined(value, message);
    assertNotNull(value, message);
}
export function assertAndReturnDefined(value, message) {
    assertDefined(value, message);
    return value;
}
//# sourceMappingURL=Assert.js.map